import { styled } from "@mui/system";
import { Box } from "@mui/material";

const LoginPageStyles = styled(Box)(({ theme }) => ({
  "& .container": {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    minHeight: "100vh",
    backgroundColor: theme.palette.background.default,
    transition: "background-color 0.3s",
  },
  "& .gridContainer": {
    width: "100%",
    height: "100%",
  },
  "& .leftSection": {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: theme.palette.background.paper,
    color: theme.palette.text.primary,
    padding: theme.spacing(4),
    borderRadius: theme.spacing(2),
    boxShadow: theme.shadows[10],
    transition: "background-color 0.3s",
  },
  "& .headerBox": {
    textAlign: "center",
  },
  "& .portalTitle": {
    fontWeight: "bold",
    marginBottom: theme.spacing(1),
    fontSize: "2.5rem",
  },
  "& .companyName": {
    fontWeight: "bold",
    fontSize: "1.5rem",
  },
  "& .rightSection": {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: theme.spacing(4),
  },
  "& .formCard": {
    width: "100%",
    maxWidth: "400px",
    padding: theme.spacing(3),
    borderRadius: theme.spacing(2),
    boxShadow: theme.shadows[5],
    backgroundColor: theme.palette.background.default,
    transition: "background-color 0.3s",
  },
  "& .textField": {
    marginTop: theme.spacing(2),
  },
  "& .loginButton": {
    marginTop: theme.spacing(2),
    borderRadius: theme.spacing(1),
  },
  "& .themeToggle": {
    position: "absolute",
    top: theme.spacing(2),
    right: theme.spacing(2),
    color: theme.palette.text.primary,
    transition: "color 0.3s",
  },
}));

export default LoginPageStyles;
